import React from "react";
import * as c from "./landingPages.module.scss";
import classNames from "classnames";
import { getLandingPageSections } from "@templates/landingPages/landingPageSections";
import Layout from "@components/layout";
import { CompetitorPageHeader } from "@components/pages/landingPages/competitorPageHeader";
import { LpCompetitorSection, LpCompetitorQuote, LpCompetitorTable } from "@components/shared/landingPage/competitor";
import { competitorComparisonPageSlugs } from "@utils/competitorComparisonPage";
import WistiaVideoEmbed from "@components/wistia/wistiaVideoEmbed";

const CompetitorPage = ({ contentfulLandingPage }) => {
  const { pageHeader, actionSections, sections, slug, embeddedWistiaVideoId, embeddedWistiaVideoTitle } =
    contentfulLandingPage;
  const { sectionComponents, actionSectionsComponents } = getLandingPageSections({
    sections,
    actionSections,
    className: c,
  });

  const hasComparisonData = competitorComparisonPageSlugs.includes(slug);

  return (
    <Layout className={classNames(c.pageWrapper, "cream-100")}>
      {!hasComparisonData && <CompetitorPageHeader pageHeaderData={pageHeader} />}

      {hasComparisonData && (
        <>
          <LpCompetitorSection slug={slug} />
          <LpCompetitorTable slug={slug} />
          <LpCompetitorQuote slug={slug} />
        </>
      )}

      <div className={c.sections}>
        {embeddedWistiaVideoId && (
          <section className={c.wistiaEmbed}>
            <h4 className="h4">{embeddedWistiaVideoTitle}</h4>
            <WistiaVideoEmbed
              wistiaOptions={"seo=false controlsVisibleOnLoad=false"}
              wistiaVideoId={embeddedWistiaVideoId}
            />
          </section>
        )}

        {!hasComparisonData && sectionComponents}
        {actionSectionsComponents}
      </div>
    </Layout>
  );
};

export default CompetitorPage;
